export default "__VITE_ASSET__BZiBxbZu__"